export class State {
  id: number;
  longDescription: number;
  shortDescription: number;
  createAt: string;
  active: number;
}
